export default {
    setSearchResults(state, search_data){
        state.search_results.products = search_data.products
        state.search_results.buyers_guides = search_data.buyers_guides
        state.search_results.categories = search_data.categories
        state.search_results.brands = search_data.brands
    },
}


// WEBPACK FOOTER //
// ./assets/js/vue/store/mutations/searchMutations.js